<template>
    <div class="modal fade text-left" id="identity_iq_modal_update">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-primary text-center" id="myModalLabel33">
                        Credit Monitoring Services
                    </h4>
                    <div class="row">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </div>
                <client-report-form></client-report-form>
            </div>
        </div>
    </div>
</template>
<script>
import { useLocalizationStore } from '../../../stores/LocalizationStore.js'
import { useReportStore } from '../../../stores/ReportStore.js'
import { useUserStore } from '../../../stores/UserStore.js'
import CreditMonitoringAgenciesModal from '../../modals/CreditMonitoringAgencies.vue';
import { openModal } from '../../../utilities/_helpers'
import CreditfixrrReportsForm from '../../report/form/CreditfixrrReportsComponent.vue'

export default {
    components: {
        CreditMonitoringAgenciesModal,
        CreditfixrrReportsForm
    },
    setup() {
        return {
            localizationStore: useLocalizationStore(),
            reportStore: useReportStore(),
            userStore: useUserStore(),
            openModal: openModal,
        }
    },
}
</script>
